/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Republic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";
import Cookies from "universal-cookie";

import TransferOrderW from "./TRFSTW";
import TransferOrderW1 from "./TRFSTW1";
import TransferOrderW2 from "./TRFSTW2";

const cookies = new Cookies();

const TransferOrder = ({ getSubModulesByRoleIdReducer, getSubModulesByRoleId }) => {
  const loginDetails = cookies.get("loginDetailsForWMS");
  const jwtToken = loginDetails?.jwt;
  const roleId = loginDetails?.data?.roleId;

  const [modulesData, setModulesData] = useState([]);

  // Fetch submodules on mount
  useEffect(() => {
    if (roleId && jwtToken) {
      getSubModulesByRoleId(roleId, jwtToken);
    }
  }, [roleId, jwtToken, getSubModulesByRoleId]);

  // Update local state from reducer
  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer?.subModulesByRoleData?.data || []
    );
  }, [getSubModulesByRoleIdReducer]);

  // Access checks
  const TRFSTWAccess = modulesData.find(
    (m) => m.moduleId === "fd5ac9f1-2b1c-440c-835d-8160799e788b"
  );

  const TRFSTW1Access = modulesData.find(
    (m) => m.moduleId === "ec810a1e-b9d0-414e-bf1c-7f6dd996f3ab"
  );
  
  const TRFSTW2Access = modulesData.find(
    (m) => m.moduleId === "b4118841-208a-4dd4-8f2e-fdf47adc851c"
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          {TRFSTWAccess && (
            <Grid item xs={12} md={12} lg={12} mt={1}>
              <TransferOrderW />
            </Grid>
          )}
          {TRFSTW1Access && (
            <Grid item xs={12} md={12} lg={12} mt={1}>
              <TransferOrderW1 />
            </Grid>
          )}
          {TRFSTW2Access && (
            <Grid item xs={12} mt={1} >
              <TransferOrderW2 />
            </Grid>
          )}
        </Grid>

        {!TRFSTWAccess && !TRFSTW1Access && !TRFSTW2Access && (
          <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
            No Transfer Order Access
          </h4>
        )}
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => ({
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferOrder);
